import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import contractFormalizationApi from '~/services/contract-formalization-api/contract-formalization-api';
import { ContractFormalizationAPI } from '~/services/contract-formalization-api/contract-formalization-api.types';
import { RefundOrigin } from '~/services/receipt-model-api/receipt-model-api.types';

interface CancelFormalizedParams {
  cancelledDate?: string;
  force?: boolean;
  origin?: RefundOrigin;
  projectId: string;
  reason: string;
}

export default function useCancelFormalized() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn:
      (params: CancelFormalizedParams) => contractFormalizationApi
        .cancelContract(params.projectId, params.reason, params.force, params.cancelledDate, params.origin),
    onError: (error: any) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      if (status === 400) {
        throw error;
      }

      const errorMessages = {
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
        409: 'Este financiamento já foi cancelado anteriormente.',
        422: 'Motivo do cancelamento é obrigatório e deve ser preenchido.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || message
        || 'Erro inesperado ao cancelar financiamento.';

      toast.error(errorMessage);
    },
    onSuccess: (data: ContractFormalizationAPI.CancelContractResponse) => {
      if (data.success) {
        toast.success('Financiamento cancelado com sucesso.');
        queryClient.invalidateQueries({ queryKey: ['financing-details'] });
        queryClient.invalidateQueries({ queryKey: ['formalization-info'] });
      }
    },
    retry: 3,
    retryDelay: 1000,
  });
}
